<template>
  <div class="big">
    <div class="page_title flex_between">
      <span>医生拍照开方重新划价</span>
      <el-button
        type="primary"
        style="width: 92px"
        size="medium"
        @click="back"
      >返回</el-button>
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="img">
          <div class="title">处方信息</div>
          <div style="text-align: left">
            <div>
              <span class="infotitle">患者</span>
              <span style="margin: 0 12px 0 15px">{{ info.user_name }}</span>
              <span v-if="info.patient_sex == 1">男</span>
              <span v-if="info.patient_sex == 2">女</span>
              <span v-if="info.patient_sex == 0">未知</span>
              <span style="margin: 0 12px">{{ info.age }}</span>
              <span>{{ info.patient_phone }}</span>
            </div>
            <div style="margin: 6px 0">
              <span>{{ info.drug_type_name }}</span>
              <span style="margin-left: 20px">{{ info.hospital_name }}</span>
            </div>
            <div>
              <span class="infotitle">剂量保密</span>
              <span style="margin-left: 20px">{{
                info.is_show ? "否" : "是"
              }}</span>
            </div>
            <div style="margin: 6px 0">
              <span class="infotitle">用法</span>
              <span style="margin-left: 20px">{{ info.use_method }}</span>
            </div>
            <div>
              <span class="infotitle">禁忌</span>
              <span style="margin-left: 20px">{{ info.taboo }}</span>
            </div>
            <div style="margin: 6px 0">
              <span class="infotitle">特殊说明</span>
              <span style="margin-left: 20px">{{ info.doctor_advice }}</span>
            </div>
            <div>
              <span class="infotitle">诊后管理费</span>
              <span style="margin-left: 20px">{{
                info.is_consult_drug ? "开启" : "关闭"
              }}</span>
            </div>
            <div style="margin: 6px 0">
              <span class="infotitle">诊金附加到药费</span>
              <span style="margin-left: 20px">{{
                info.gold_join ? "是" : "否"
              }}</span>
            </div>
            <div>
              <span class="infotitle">诊金金额</span>
              <span style="margin-left: 20px">{{ info.consulting_gold }}</span>
            </div>
            <div style="margin: 6px 0">
              <span class="infotitle">客服备注</span>
              <span style="margin-left: 20px">{{ info.remark }}</span>
            </div>
          </div>
          <div class="title flex_between">
            <span>原处方图片</span>
            <el-button
              @click="rotate"
              type="primary"
            >旋转图片</el-button>
          </div>
          <div
            class="imgbox"
            ref="rotate"
          >
            <el-image
              class="preimg"
              :src="info.pre_picture"
              :preview-src-list="[info.pre_picture]"
              fit="contain"
            ></el-image>
          </div>
        </div>
        <div class="prebox">
          <div class="flex between">
            <div>
              <span class="title">医生信息</span>
              <span style="margin: 0 12px 0 15px">{{ info.doctor_name }}</span>
              <span v-if="info.doctor_sex == 1">男</span>
              <span v-if="info.doctor_sex == 2">女</span>
              <span v-if="info.doctor_sex == 0">未知</span>
              <span style="margin: 0 12px">{{ info.title }}</span>
              <span>{{ info.doctor_phone }}</span>
              <span style="margin-left: 12px">{{ info.department_name }}</span>
            </div>

            <el-button
              type="primary"
              @click="clearPrescription"
            >清空处方</el-button>
          </div>
          <div class="pre">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              :inline="true"
              label-width="80px"
              label-position="right"
              class="myform"
            >
              <!-- 患者信息 -->
              <div class="title">患者信息</div>
              <el-form-item
                prop="user_name"
                label="姓名"
              >
                <el-input
                  v-model="ruleForm.user_name"
                  style="width: 200px"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="sex"
                label="性别"
              >
                <el-radio-group v-model="ruleForm.sex">
                  <el-radio :label="1">男</el-radio>
                  <el-radio :label="2">女</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="年龄"
                prop="year"
              >
                <el-input-number
                  v-model="ruleForm.year"
                  :controls="false"
                  :min="0"
                  :max="120"
                  style="width: 60px"
                />
                <span style="margin: 0 5px">岁</span>
                <el-input-number
                  v-model="ruleForm.month"
                  :controls="false"
                  :min="0"
                  :max="12"
                  style="width: 60px; margin-right: 5px"
                />
                <span>个月</span>
              </el-form-item>

              <span class="myselect">
                <el-form-item
                  label="主诉"
                  prop="chief_complaint"
                >
                  <el-select
                    v-model="ruleForm.chief_complaint"
                    multiple
                    filterable
                    allow-create
                    remote
                    style="width: 325px"
                    ref="chief_complaint"
                    :popper-append-to-body="false"
                    default-first-option
                    :remote-method="symptomRemote"
                    class="chief_complaint"
                  >
                    <el-option
                      v-for="item in symptom_remote_list"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                    <div class="frequency flex wrap">
                      <span
                        @click="addFrequency(item)"
                        v-for="item in frequencyList"
                        :key="item"
                      >{{ item }}</span>
                    </div>
                    <p
                      class="close"
                      @click="closeSelect(3)"
                    >关闭</p>
                  </el-select>
                </el-form-item>
              </span>
              <span class="myselect">
                <el-form-item
                  prop="diagnosis"
                  label="诊断"
                >
                  <el-select
                    v-model="ruleForm.diagnosis"
                    multiple
                    filterable
                    allow-create
                    remote
                    style="width: 325px"
                    ref="diagnosis"
                    :popper-append-to-body="false"
                    default-first-option
                    :remote-method="diseaseRemote"
                  >
                    <el-option
                      v-for="item in disease_remote_list"
                      :key="item"
                      :label="item"
                      :value="item"
                    />
                    <p
                      class="close"
                      @click="closeSelect(4)"
                    >关闭</p>
                  </el-select>
                </el-form-item>
              </span>
              <!-- 处方信息 -->
              <div class="title between align-center">处方信息</div>
              <el-form-item
                label="药品剂型"
                prop="drug_type"
              >
                <el-radio-group
                  v-model="ruleForm.drug_type"
                  @change="getHospitalList"
                >
                  <el-radio
                    :label="item.drug_type"
                    v-for="(item, index) in drugTypeList"
                    :key="index"
                  >{{ item.drug_type_name }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="药房"
                prop="hospital_id"
              >
                <el-select
                  v-model="ruleForm.hospital_id"
                  placeholder="请选择"
                  @change="changeDrugsMsg"
                >
                  <el-option
                    v-for="item in hospitalList"
                    :key="item.hospital_id"
                    :label="item.hospital_name"
                    :value="item.hospital_id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- 药品信息 -->
              <div class="medicine-table">
                <div class="top">中药处方</div>
                <div class="medicine-box flex wrap align-center">
                  <div
                    class="item flex between align-center"
                    v-for="(item, index) in ruleForm.medicine"
                    :key="index"
                  >
                    <el-select
                      v-model="item.generic_name"
                      placeholder="添加中药/简拼"
                      class="name-input"
                      clearable
                      filterable
                      remote
                      :remote-method="remoteMedicine"
                      value-key="generic_name"
                      @focus="(item) => judeMedicine(item, index)"
                      @change="(item) => selectMedicine(item, index)"
                      @blur="changeMedicine(item)"
                      @clear="(item) => clearMedicine(item, index)"
                    >
                      <i
                        slot="prefix"
                        class="el-input__icon el-icon-plus"
                      />
                      <el-option
                        v-for="item in drug_remote_list"
                        :key="item.drug_id"
                        :label="item.generic_name"
                        :value="item"
                      />
                    </el-select>
                    <div
                      class="count-input"
                      v-show="item.drug_id"
                      :class="item.max ? 'max' : ''"
                    >
                      <el-input
                        type="text"
                        size="mini"
                        v-model="item.item_use_level"
                        @change="(value) => numberChange(value, item)"
                      ></el-input>
                      <span>g</span>
                    </div>
                    <div
                      class="use-input"
                      v-show="item.drug_id"
                    >
                      <el-select
                        v-model="item.requirement"
                        placeholder="煎法"
                        size="mini"
                        clearable
                      >
                        <el-option
                          v-for="item in medicineUseList"
                          :key="item.decocting_name"
                          :label="item.decocting_name"
                          :value="item.decocting_name"
                        />
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
              <div style="height: 40px; line-height: 40px">
                <span style="margin-right: 10px">服用方式</span>
                <el-radio
                  v-model="ruleForm.use_type"
                  :label="1"
                >内服</el-radio>
                <el-radio
                  v-model="ruleForm.use_type"
                  :label="2"
                >外用</el-radio>
              </div>
              <div class="medicine-info flex align-center">
                <div class="flex align-center">
                  共
                  <span style="margin: 0 5px">{{ medicine_count }}</span>
                  味中药
                  <span style="margin-left: 15px">共</span>
                  <el-form-item prop="total_num">
                    <el-input-number
                      v-model="ruleForm.total_num"
                      :step="1"
                      step-strictly
                      :min="1"
                      :controls="false"
                      size="mini"
                      ref="total_num"
                      @change="changeTotalNum"
                    />
                  </el-form-item>剂
                  <div>每日1剂</div>
                  <div v-if="ruleForm.use_type == 1">
                    每剂分
                    <el-input-number
                      v-model="ruleForm.day_num"
                      :step="1"
                      step-strictly
                      :min="1"
                      :max="3"
                      :controls="false"
                      size="mini"
                      ref="day_num"
                    />次服用
                  </div>
                  <div v-if="ruleForm.use_type == 2">
                    分
                    <el-input-number
                      v-model="ruleForm.day_num"
                      :step="1"
                      step-strictly
                      :min="1"
                      :max="3"
                      :controls="false"
                      size="mini"
                      ref="day_num"
                    />次使用
                  </div>
                </div>
              </div>
              <div class="pricebox">
                <div class="price">
                  <div>
                    <span style="margin-right: 40px">每剂</span>
                    <span>¥{{ price_item }}</span>
                  </div>
                  <div style="margin-top: 10px">
                    <span style="margin-right: 12px">药品金额</span>
                    <span>¥{{ drugs_price }}</span>
                  </div>
                  <div style="margin: 10px 0 10px">
                    <el-checkbox v-model="ruleForm.is_consult"></el-checkbox>
                    <span style="margin: 0 15px 0 2px; color: #707070">诊后管理费</span>
                    <el-input-number
                      v-model="ruleForm.consult_drug_price"
                      :precision="0"
                      :step="1"
                      :max="max_price"
                      :controls="false"
                      style="width: 120px"
                      :disabled="!ruleForm.is_consult"
                    ></el-input-number>
                    <span style="color: #f69637; margin-left: 10px">最大不允许超过{{ max_price }}元</span>
                  </div>
                  <div>
                    <span style="margin-right: 10px">诊金附加到药费</span>
                    <el-radio
                      v-model="ruleForm.gold_join"
                      :label="1"
                    >是</el-radio>
                    <el-radio
                      v-model="ruleForm.gold_join"
                      :label="0"
                    >否</el-radio>
                  </div>
                  <div style="margin: 10px 0 20px">
                    <span style="margin-right: 73px">诊金</span>
                    <el-input-number
                      v-model="ruleForm.consulting_gold"
                      :controls="false"
                      style="width: 120px"
                    ></el-input-number>
                  </div>
                  <div style="margin: -10px 0 10px">
                    <span style="margin-right: 10px">费用总计</span>
                    <span>¥{{
                        drugs_price
                          ? (
                              Number(drugs_price) +
                              (ruleForm.consult_drug_price
                                ? ruleForm.consult_drug_price
                                : 0) +
                              (ruleForm.consulting_gold
                                ? ruleForm.consulting_gold
                                : 0)
                            ).toFixed(2)
                          : 0
                      }}</span>
                  </div>
                  <div style="height: 40px; line-height: 40px">
                    <span style="margin-right: 10px">剂量保密</span>
                    <el-radio
                      v-model="ruleForm.is_show"
                      :label="0"
                    >是</el-radio>
                    <el-radio
                      v-model="ruleForm.is_show"
                      :label="1"
                    >否</el-radio>
                  </div>
                </div>
                <el-button
                  type="text"
                  style="margin-left: 10px"
                  @click="showprice"
                >价格明细</el-button>
              </div>

              <el-form-item label="用法">
                <el-select
                  v-model="ruleForm.use_method"
                  placeholder="请选择"
                  style="width: 200px"
                  ref="use_method"
                >
                  <el-option
                    v-for="item in preUseList"
                    :key="item.use_name"
                    :label="item.use_name"
                    :value="item.use_name"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="禁忌">
                <el-select
                  v-model="ruleForm.taboo"
                  multiple
                  filterable
                  allow-create
                  remote
                  ref="taboo"
                  :popper-append-to-body="false"
                  style="width: 450px"
                  default-first-option
                  placeholder="请选择或填写"
                  class="taboo"
                >
                  <el-option
                    v-for="item in tabooList"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                  <p
                    class="close"
                    @click="closeSelect(5)"
                  >关闭</p>
                </el-select>
              </el-form-item>
              <el-form-item label="特殊说明">
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入"
                  v-model="ruleForm.doctor_advice"
                  style="width: 740px"
                  ref="advice"
                ></el-input>
              </el-form-item>
            </el-form>
            <div style="margin-top: 50px">
              <el-button
                type="warning"
                @click="submit(2)"
                size="medium"
                style="margin-right: 10px"
              >提交医生确认</el-button>
              <el-button
                type="primary"
                @click="submit(3)"
                size="medium"
              >完成划价，发送患者</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 药品明细弹窗 -->
    <el-dialog
      title="价格明细"
      :visible.sync="pricebox"
      width="500px"
      center
      :close-on-click-modal="false"
    >
      <div style="padding: 15px">
        <div>
          每剂共
          <span style="color: #c41d1d; font-weight: 600">{{
            medicine_count
          }}</span>
          味药材，共计
          <span style="color: #c41d1d; font-weight: 600">{{
            drugs_price
          }}</span>
          元
        </div>
        <div style="margin-top: 20px">
          <el-table
            :data="priceList"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="generic_name"
              label="药品名称"
            ></el-table-column>
            <el-table-column label="价格">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.price }} * {{ scope.row.item_use_level }}g =
                  {{
                    (
                      Number(scope.row.price) * Number(scope.row.item_use_level)
                    ).toFixed(2)
                  }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
import { errorMonitor } from 'events';
export default {
  name: 'savePre',
  data() {
    return {
      price_item: 0,
      drugs_price: 0,
      pricebox: false,
      priceList: [],
      deg: 0,
      info: {}, //处方详情
      proportion: 0, //诊后管理费系数
      frequencyList: [
        '一天',
        '两天',
        '三天',
        '一周',
        '一月',
        '两月',
        '半年',
        '最近',
        '偶尔',
        '经常'
      ],
      hospitalList: [],
      ruleForm: {
        user_name: '',
        year: '',
        month: '',
        sex: 1,
        drug_type: '',
        hospital_id: '',
        chief_complaint: [], //主诉
        diagnosis: [], //诊断
        department_name: '',
        consult_drug_price: 0, //诊后管理费
        is_consult: true,
        use_type: 1, //服用方式
        is_show: 0, //隐藏剂量
        gold_join: 1, //诊金是否加入药品金额
        consulting_gold: undefined, //诊金
        medicine: [
          {
            drug_id: '',
            generic_name: '',
            item_use_level: '',
            requirement: '',
            max: false,
            stock: 0,
            special_drug: 0,
            special_drug_level: 0,
            price: ''
          },
          {
            drug_id: '',
            generic_name: '',
            item_use_level: '',
            requirement: '',
            max: false,
            stock: 0,
            special_drug: 0,
            special_drug_level: 0,
            price: ''
          }
        ],
        total_num: '',
        day_num: '',
        use_method: '', //用法
        doctor_advice: '', //医嘱
        taboo: [] //禁忌
      },
      rules: {
        user_name: [
          { required: true, message: '请输入姓名' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符' }
        ],
        sex: [{ required: true, message: '请选择性别', trigger: 'blur' }],
        year: [{ required: true, message: '请输入年龄', trigger: 'blur' }],
        drug_type: [
          { required: true, message: '请选择药品剂型', trigger: 'blur' }
        ],
        hospital_id: [
          { required: true, message: '请选择药房', trigger: 'blur' }
        ],
        chief_complaint: [{ required: true, message: '请输入主诉' }],
        diagnosis: [{ required: true, message: '请输入诊断' }],
        department_name: [{ required: true, message: '请选择科室' }],
        total_num: [{ required: true, message: '请选择剂数' }]
      },
      symptom_default_list: [], //医生常用主诉列表
      preUseList: [], //处方用法
      disease_default_list: [], //医生常用诊断列表
      medicineUseList: [], //药品煎法
      tabooList: [], //禁忌列表
      drug_remote_list: [],
      symptom_remote_list: [], // 主诉远程搜索列表
      disease_remote_list: [], //诊断远程搜索列表
      drugTypeList: [] //药房可选剂型列表
    };
  },
  computed: {
    //药材种类
    medicine_count() {
      let arr = this.ruleForm.medicine.filter((ele) => {
        return ele.drug_id && !ele.max;
      });
      return arr.length;
    },
    //诊后管理费最大值
    max_price() {
      return Math.floor(this.drugs_price * this.proportion)
        ? Math.floor(this.drugs_price * this.proportion)
        : 0;
    }
  },
  watch: {
    'ruleForm.medicine': {
      handler(newValue, oldValue) {
        //添加新的格子
        let type = true;
        this.ruleForm.medicine.forEach((ele) => {
          if (!ele.generic_name) {
            type = false;
          }
        });
        if (type) {
          let count = 2 - (newValue.length % 2);
          count = count == 0 ? 2 : count;
          let arr = [];
          for (let i = 0; i < count; i++) {
            arr.push({
              drug_id: '',
              generic_name: '',
              item_use_level: '',
              requirement: '',
              max: false,
              stock: 0,
              special_drug_level: 0,
              price: ''
            });
          }
          this.ruleForm.medicine = this.ruleForm.medicine.concat(arr);
        }
        //如果倒数第三个位置没有药品 删除最后两个空格子
        let length = this.ruleForm.medicine.length;
        if (length > 3 && !this.ruleForm.medicine[length - 3].drug_id) {
          this.ruleForm.medicine.splice(length - 2, 2);
        }
      },
      deep: true
    }
  },
  methods: {
    // 旋转图片
    rotate() {
      this.deg += 90;
      if (this.deg >= 360) {
        this.deg = 0;
      }
      this.$refs.rotate.style.transform = `rotate(${this.deg}deg)`;
    },
    //价格明细按钮
    showprice() {
      this.priceList = [];
      this.ruleForm.medicine.map((item) => {
        if (item.drug_id && !item.max) {
          this.priceList.push(item);
        }
      });
      this.pricebox = true;
    },
    //获取处方信息
    getInfo() {
      let loading = this.$loading();
      let pre_id = this.$route.query.pre_id;
      this.axios
        .post('platform/prescription/prescriptionItem', { pre_id })
        .then((res) => {
          this.info = res.data.info;
          let info = res.data.info;
          this.ruleForm.user_name = info.user_name;
          this.ruleForm.pre_id = info.pre_id;
          this.ruleForm.sex = info.patient_sex;
          this.ruleForm.day_num = info.day_num ? info.day_num : 3;
          this.ruleForm.total_num = info.total_num ? info.total_num : 2;
          this.ruleForm.taboo = info.taboo ? info.taboo.split(',') : '';
          this.ruleForm.use_method = info.use_method;
          this.ruleForm.is_show = info.is_show;
          this.ruleForm.doctor_advice = info.doctor_advice;
          this.ruleForm.is_consult = info.is_consult_drug ? true : false;
          this.ruleForm.gold_join = info.gold_join;
          this.ruleForm.consulting_gold = Number(info.consulting_gold);
          this.ruleForm.chief_complaint = info.chief_complaint.split(',');
          this.ruleForm.diagnosis = info.diagnosis.split(',');
          this.ruleForm.consult_drug_price = Number(info.consult_drug_price);
          this.ruleForm.medicine = info.item_list;
          this.ruleForm.consult_drug_price = this.info.consult_drug_price
            ? Number(this.info.consult_drug_price)
            : undefined;

          //未满月
          if (info.age == '未满月') {
            this.ruleForm.year = 0;
            this.ruleForm.month = 0;
          }
          //5个月
          if (info.age.indexOf('岁') == -1 && info.age.indexOf('个月') != -1) {
            let i = info.age.indexOf('个月');
            this.ruleForm.year = 0;
            this.ruleForm.month = info.age.substring(0, i);
          }
          //18岁
          if (info.age.indexOf('岁') != -1 && info.age.indexOf('个月') == -1) {
            let i = info.age.indexOf('岁');
            this.ruleForm.year = info.age.substring(0, i);
            this.ruleForm.month = 0;
          }
          //2岁10个月
          if (info.age.indexOf('岁') != -1 && info.age.indexOf('个月') != -1) {
            let i = info.age.indexOf('岁');
            let j = info.age.indexOf('个月');
            this.ruleForm.year = info.age.substring(0, i);
            this.ruleForm.month = info.age.substring(i + 1, j - i + 1);
          }
          setTimeout(() => {
            let drug_type_data = this.drugTypeList.find((ele) => {
              return ele.drug_type_name == info.drug_type_name;
            });
            this.ruleForm.drug_type = drug_type_data.drug_type;
            let data = {
              drug_type: this.ruleForm.drug_type
            };
            this.axios
              .post('platform/photograph/getHospitalList', data)
              .then((res) => {
                this.hospitalList = res.data.list;
              });
          }, 300);
          setTimeout(() => {
            let hospital_data = this.hospitalList.find((ele) => {
              return ele.hospital_name == info.hospital_name;
            });
            this.ruleForm.hospital_id = hospital_data.hospital_id;
            if (hospital_data) {
              this.ruleForm.hospital_id = hospital_data.hospital_id;
              let data = {
                hospital_id: this.ruleForm.hospital_id,
                doctor_id: info.doctor_id,
                drug_type: this.ruleForm.drug_type
              };
              this.axios
                .post('platform/photograph/getHospitalDoctorProportion', data)
                .then((res) => {
                  if (res.code == 0) {
                    this.proportion = res.data.proportion;
                  }
                });
            }
          }, 1000);
          setTimeout(() => {
            this.changeDrugsMsg();
            loading.close();
          }, 1000);
        });
    },
    //获取平台开方可以选择的剂型列表
    getDrugTypeList() {
      let platform_type = 1;
      this.axios
        .post('platform/photograph/getDrugTypeList', { platform_type })
        .then((res) => {
          this.drugTypeList = res.data.list;
        });
    },
    //获取药品煎法
    getSystemDecocting() {
      this.axios.post('platform/template/getSystemDecocting').then((res) => {
        this.medicineUseList = res.data.list;
      });
    },
    //获取处方用法
    getSystemUse() {
      this.axios.post('platform/template/getSystemUse').then((res) => {
        this.preUseList = res.data.list;
      });
    },
    //获取药房列表
    getHospitalList() {
      this.ruleForm.consult_drug_price = undefined;
      this.drugs_price = 0;
      this.price_item = 0;
      let data = {
        drug_type: this.ruleForm.drug_type
      };
      this.axios
        .post('platform/photograph/getHospitalList', data)
        .then((res) => {
          this.hospitalList = res.data.list;
          let index = this.hospitalList.findIndex((ele) => {
            return ele.hospital_id == this.ruleForm.hospital_id;
          });
          if (index == -1) {
            this.ruleForm.hospital_id = '';
          } else {
            let data = {
              hospital_id: this.ruleForm.hospital_id,
              doctor_id: this.info.doctor_id,
              drug_type: this.ruleForm.drug_type
            };
            this.axios
              .post('platform/photograph/getHospitalDoctorProportion', data)
              .then((res) => {
                if (res.code == 0) {
                  this.proportion = res.data.proportion;
                }
              });
          }
          let arr = this.ruleForm.medicine.filter((ele) => {
            return ele.drug_id;
          });
          if (arr.length > 0) {
            this.changeTotalNum();
          }
        });
    },
    //获取常用禁忌
    getSystemTaboo() {
      this.axios.post('platform/template/getSystemTaboo').then((res) => {
        let list = res.data.list;
        let arr = list.map((ele) => {
          return ele.taboo_name;
        });
        this.tabooList = arr;
      });
    },
    //获取常用主诉和常用诊断
    getDoctorOftenList() {
      this.axios.post('platform/photograph/getDoctorOftenList').then((res) => {
        let symptom_remote_list = res.data.symptom_list;
        let disease_remote_list = res.data.disease_list;
        let arr1 = symptom_remote_list.map((ele) => {
          return ele.symptom_name;
        });
        let arr2 = disease_remote_list.map((ele) => {
          return ele.disease_name;
        });
        this.symptom_default_list = arr1;
        this.disease_default_list = arr2;
        this.symptom_remote_list = arr1;
        this.disease_remote_list = arr2;
      });
    },
    //获取医生主诉列表
    symptomRemote(symptom_name) {
      if (!symptom_name) {
        this.symptom_remote_list = this.symptom_default_list;
        return;
      }
      this.axios
        .post('platform/photograph/getClinicalSymptomList', { symptom_name })
        .then((res) => {
          let list = res.data.list;
          list = list.map((ele) => {
            return ele.symptom_name;
          });
          this.symptom_remote_list = list;
        });
    },
    //获取诊断主诉列表
    diseaseRemote(disease_name) {
      if (!disease_name) {
        this.disease_remote_list = this.disease_default_list;
        return;
      }
      this.axios
        .post('platform/photograph/getDiseaseList', { disease_name })
        .then((res) => {
          let list = res.data.list;
          list = list.map((ele) => {
            return ele.disease_name;
          });
          this.disease_remote_list = list;
        });
    },
    //添加替换主诉频次
    addFrequency(item) {
      if (this.ruleForm.chief_complaint.length == 0) {
        return;
      }
      let symptomList = this.ruleForm.chief_complaint;
      let chief_complaint = symptomList[symptomList.length - 1];
      this.frequencyList.forEach((ele) => {
        chief_complaint = chief_complaint.replace(ele, '');
      });
      chief_complaint = chief_complaint + item;
      this.$set(
        this.ruleForm.chief_complaint,
        symptomList.length - 1,
        chief_complaint
      );
    },
    //更改药房重新判断药品
    changeDrugsMsg(value) {
      if (value) {
        let data = {
          hospital_id: value,
          doctor_id: this.info.doctor_id,
          drug_type: this.ruleForm.drug_type
        };
        this.axios
          .post('platform/photograph/getHospitalDoctorProportion', data)
          .then((res) => {
            if (res.code == 0) {
              this.proportion = res.data.proportion;
            }
          });
      }
      if (!this.ruleForm.hospital_id) {
        this.ruleForm.medicine.forEach((ele) => {
          if (ele.drug_id) {
            ele.stock = 0;
            ele.max = true;
            this.$forceUpdate();
          }
        });
        return false;
      }
      let historyarr = _.cloneDeep(this.ruleForm.medicine);
      let items = [];
      if (this.ruleForm.medicine[0].drug_id) {
        this.ruleForm.medicine.map((item) => {
          if (item.drug_id) {
            items.push({ generic_name: item.generic_name });
          }
        });
      } else {
        return false;
      }
      let data = {
        items: items,
        drug_type: this.ruleForm.drug_type,
        hospital_id: this.ruleForm.hospital_id
      };
      this.axios
        .post('platform/photograph/getTcmTemplateGoodsList', data)
        .then((res) => {
          let medicine = res.data.list.map((item) => {
            item.item_use_level = 0;
            item.max = false;
            return item;
          });
          historyarr.forEach((hisele) => {
            if (hisele.drug_id) {
              let obj = medicine.find((nowele) => {
                return nowele.generic_name == hisele.generic_name;
              });
              //缺药
              if (!obj) {
                hisele.stock = 0;
                hisele.max = true;
              } else {
                hisele.stock = obj.stock;
                hisele.price = obj.price;
                hisele.drug_id = obj.drug_id;
                hisele.max =
                  hisele.stock < hisele.item_use_level ? true : false;
              }
            }
          });
          this.ruleForm.medicine = historyarr;
          this.$forceUpdate();
          this.changeTotalNum();
        });
    },
    //远程搜索药品
    remoteMedicine(keywords) {
      if (!keywords) {
        return;
      }
      let isChinese = this.checkChinese(keywords);
      let data = {
        drug_type: this.ruleForm.drug_type,
        keywords: keywords,
        hospital_id: this.ruleForm.hospital_id
      };
      this.axios
        .post('platform/photograph/getHospitalGoodsList', data)
        .then((res) => {
          this.drug_remote_list = res.data.list;
        });
    },
    //判断是否是中文
    checkChinese(str) {
      let reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
      if (reg.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    //选择药品
    selectMedicine(item, index) {
      if (!item.drug_id) return;
      let obj = {
        drug_id: item.drug_id,
        generic_name: item.generic_name,
        item_use_level: '',
        stock: item.stock || 0,
        requirement: '',
        special_drug: item.special_drug,
        special_drug_level: item.special_drug_level,
        price: item.price,
        max: false
      };

      let medicine = JSON.parse(JSON.stringify(this.ruleForm.medicine));
      let repetition = medicine.find((ele) => {
        return ele.generic_name && ele.generic_name == item.generic_name;
      });
      //暂时用空位占据
      this.ruleForm.medicine.splice(index, 1, {
        drug_id: '',
        generic_name: '',
        item_use_level: '',
        requirement: '',
        max: false,
        stock: 0,
        special_drug_level: 0,
        price: ''
      });
      if (repetition && repetition.drug_id) {
        //重复不能添加
        this.$message({
          message: item.generic_name + '已经填写！',
          type: 'error'
        });
      } else {
        //添加到第一个没有填写的格子
        let setIndex = this.ruleForm.medicine.findIndex((ele) => {
          return !ele.drug_id;
        });
        this.ruleForm.medicine.splice(setIndex, 1, obj);
      }
    },
    //获取焦点时如果该栏没有药品，清空drug_remote_list，如果有药品，将drug_remote_list 等于该药品
    judeMedicine(item) {
      if (!item.generic_name) {
        this.drug_remote_list = [];
      } else {
        this.drug_remote_list = item;
      }
    },
    //清空药品
    clearMedicine(item, index) {
      this.ruleForm.medicine.splice(index, 1);
      this.ruleForm.medicine.push({
        drug_id: '',
        generic_name: '',
        item_use_level: '',
        requirement: '',
        max: false,
        stock: 0,
        special_drug_level: 0,
        price: ''
      });
      let price_arr = this.ruleForm.medicine.map((item) => {
        return Number(item.price) * Number(item.item_use_level);
      });
      let price_item = 0;
      price_arr.forEach((item) => {
        price_item += Number(item);
      });
      this.price_item = price_item.toFixed(2);
      this.drugs_price = (price_item * Number(this.ruleForm.total_num)).toFixed(
        2
      );
    },
    //改变剂数
    changeTotalNum() {
      let price_arr = [];
      this.ruleForm.medicine.map((item) => {
        if (!item.max) {
          price_arr.push(Number(item.price) * Number(item.item_use_level));
        }
      });
      let price_item = 0;
      price_arr.forEach((item) => {
        price_item += Number(item);
      });
      this.price_item = price_item.toFixed(2);
      this.drugs_price = (price_item * Number(this.ruleForm.total_num)).toFixed(
        2
      );
      this.ruleForm.consult_drug_price = this.info.consult_drug_price
        ? Number(this.info.consult_drug_price)
        : undefined;
    },
    //失去焦点后判断药品是否正确
    changeMedicine(item) {
      let drug = this.drug_remote_list.find((ele) => {
        if (ele.drug_id == item.drug_id) {
          return ele;
        }
      });
      if (drug) {
        item.generic_name = drug.generic_name;
      }
    },
    //药品数量改变判断库存是否满
    numberChange(value, item) {
      this.$set(item, 'max', false);
      if (!value || !/(^[1-9]\d*$)/.test(value)) {
        this.$message.error('请输入正整数！');
        item.max = true;
        item.item_use_level = '';
        return false;
      }
      item.max = false;
      if (
        item.stock < item.item_use_level * this.ruleForm.total_num &&
        value != 0
      ) {
        item.max = true;
        this.$message.error(item.generic_name + '现有库存量为' + item.stock);
      } else {
        this.$set(item, 'max', false);
      }

      let price_arr = this.ruleForm.medicine.map((item) => {
        return Number(item.price) * Number(item.item_use_level);
      });
      let price_item = 0;
      price_arr.forEach((item) => {
        price_item += Number(item);
      });
      this.price_item = price_item.toFixed(2);
      this.drugs_price = (price_item * Number(this.ruleForm.total_num)).toFixed(
        2
      );
    },
    //清空处方模板
    clearPrescription() {
      this.ruleForm.user_name = '';
      this.ruleForm.year = '';
      this.ruleForm.month = '';
      this.ruleForm.sex = 1;
      this.ruleForm.diagnosis = [];
      this.ruleForm.chief_complaint = [];
      this.ruleForm.total_num = 2;
      this.ruleForm.day_num = 3;
      this.ruleForm.use_method = '';
      this.ruleForm.use_type = 1;
      this.ruleForm.doctor_advice = '';
      this.ruleForm.taboo = [];
      this.ruleForm.consult_drug_price = undefined;
      this.ruleForm.consulting_gold = undefined;
      this.ruleForm.is_consult = true;
      this.ruleForm.medicine = [
        {
          drug_id: '',
          generic_name: '',
          item_use_level: '',
          requirement: '',
          max: false,
          stock: 0,
          special_drug: 0,
          special_drug_level: 0,
          price: ''
        },
        {
          drug_id: '',
          generic_name: '',
          item_use_level: '',
          requirement: '',
          max: false,
          stock: 0,
          special_drug: 0,
          special_drug_level: 0,
          price: ''
        }
      ];
    },
    //关闭select下拉
    closeSelect(type) {
      switch (type) {
        case 3:
          this.$refs.chief_complaint.blur();
        case 4:
          this.$refs.diagnosis.blur();
          break;
        case 5:
          this.$refs.taboo.blur();
          break;
      }
    },
    //提交
    submit(is_doctor_sure) {
      if (this.ruleForm.medicine.length == 0) {
        this.$message.error('请输入药材及药材数量');
        return false;
      }
      let medicine = this.ruleForm.medicine;
      for (let i = 0; i < medicine.length; i++) {
        if (!medicine[i].item_use_level && medicine[i].drug_id) {
          this.$message.error('请输入药材用量');
          return;
        }
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading();
          let items = [];
          medicine.map((item) => {
            item = _.pick(item, [
              'drug_id',
              'generic_name',
              'item_use_level',
              'requirement'
            ]);
            if (item.drug_id) {
              items.push(item);
            }
          });
          let data = {
            pai_id: this.ruleForm.pre_id,
            hospital_id: this.ruleForm.hospital_id,
            user_name: this.ruleForm.user_name,
            sex: this.ruleForm.sex,
            chief_complaint: this.ruleForm.chief_complaint.toString(),
            diagnosis: this.ruleForm.diagnosis.toString(),
            taboo: this.ruleForm.taboo.toString(),
            use_method: this.ruleForm.use_method,
            doctor_advice: this.ruleForm.doctor_advice,
            department_name: this.info.department_name,
            drug_type: this.ruleForm.drug_type,
            total_num: this.ruleForm.total_num,
            day_num: this.ruleForm.day_num,
            is_consult_drug: this.ruleForm.is_consult ? 1 : 0,
            consult_drug_price: this.ruleForm.consult_drug_price,
            use_type: this.ruleForm.use_type,
            is_show: this.ruleForm.is_show,
            gold_join: this.ruleForm.gold_join,
            consulting_gold: this.ruleForm.consulting_gold,
            doctor_id: this.info.doctor_id,
            items: items,
            is_doctor_sure: is_doctor_sure
          };
          let year = this.ruleForm.year;
          let month = this.ruleForm.month;
          if (year == 0 && month == 0) {
            data.age = '未满月';
          }
          if (year == 0 && month > 0) {
            data.age = month + '个月';
          }
          if (0 < year < 3 && month >= 0) {
            data.age = year + '岁' + month + '个月';
          }
          if (year >= 3 && month > 0) {
            data.age = year + '岁' + month + '个月';
          }
          if (year >= 3 && month == 0) {
            data.age = year + '岁';
          }
          this.axios
            .post('platform/photograph/savePhotoPrescription', data)
            .then((res) => {
              if (res.code == 0) {
                loading.close();
                this.$message.success('提交成功');
                this.back();
              } else {
                loading.close();
              }
            })
            .catch((err) => {
              loading.close();
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    back() {
      history.back();
    }
  },
  created() {
    this.getDrugTypeList(); //获取平台开方可以选择的剂型列表
    this.getSystemDecocting(); //获取药品煎法
    this.getSystemUse(); //获取处方用法
    this.getDoctorOftenList(); //获取常用主诉和诊断病症列表
    this.getSystemTaboo(); //获取处方禁忌
    this.getInfo(); //获取处方信息
  }
};
</script> 
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  display: flex;
  justify-content: space-between;
  padding: 20px;
  .title {
    font-weight: 700;
    font-size: 16px;
    text-align: left;
    margin-bottom: 10px;
  }
}
.infotitle {
  font-weight: 700;
}
.img {
  width: 39%;
  max-height: calc(100vh - 60px);

  .imgbox {
    width: 100%;
    height: 88%;
    z-index: 1000;
    position: relative;
  }
  .preimg {
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
.prebox {
  width: 60%;
  .myform {
    text-align: left;
  }
}
.pre {
  background: #f3f3f3;
  padding: 20px;
  margin-top: 10px;
  min-height: calc(100vh - 100px);
}
.close {
  text-align: center;
  line-height: 40px;
  margin: 0;
  cursor: pointer;
  border-top: 1px solid #eeeeee;
  width: 100%;
  &:hover {
    color: #1890ff;
  }
}
.frequency {
  width: 100%;
  line-height: 40px;
  border-top: 1px solid #eeeeee;
  span {
    box-sizing: border-box;
    padding: 0 20px;
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
  }
}
.medicine-table {
  border: 1px solid #c4cbd9;
  border-bottom: none;
  width: 100%;
  .top {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    border-bottom: 1px solid #c4cbd9;
    background-color: #dddddd;
    line-height: 40px;
    padding-left: 10px;
    font-weight: 600;
  }
}
.medicine-box {
  .item {
    border-bottom: 1px solid #c4cbd9;
    border-left: 1px solid #c4cbd9;
    background-color: #fff;
    box-sizing: border-box;
    width: 50%;
    padding-right: 10px;
    &:nth-of-type(2n + 1) {
      border-left: none;
    }
    .name-input {
      flex: 1;
    }
    .count-input {
      width: 90px;
      margin-right: 5px;
      border: 1px solid #ccc;
      &.max {
        border: 1px solid #ff514b;
      }
      .el-input {
        width: 75px;
      }
    }
    .use-input {
      width: 100px;
      border: 1px solid #ccc;
    }
  }
}
.medicine-info {
  padding: 5px;
  padding-left: 10px;
  border-radius: 2px;
  border: solid 1px #c4cbd9;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  height: 40px;
  font-size: 12px;
  div {
    margin: 0 10px;
  }
  .el-input-number {
    width: 60px;
  }
}
.pricebox {
  padding-left: 20px;
  display: flex;
  justify-content: flex-start;
  align-self: flex-start;
  align-content: flex-start;
  align-items: flex-start;
  margin-bottom: 30px;
  .price {
    padding-top: 10px;
  }
}
</style>
<style lang="scss">
.medicine-box .el-input__inner {
  border: 0;
  border-radius: 0%;
  border-color: transparent;
}
.myselect .el-select-dropdown__list {
  display: flex;
  flex-wrap: wrap;
}
</style>